import Vue from 'vue'
import App from './App'
import VRouter from './Router'
import VueFire from 'vuefire'
import vValidator from 'vue-validator'
import { store } from './index'

import moment from 'moment'
const timeFormat = 'YYYY/MM/DD HH:mm:ss'

Vue.use(vValidator)
Vue.use(VRouter)
Vue.use(VueFire)

Vue.validator('email', val => {
  return /^[-a-z0-9~!$%^&*_=+}{\\'?]+(\.[-a-z0-9~!$%^&*_=+}{\\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
    .test(val)
})

Vue.filter('timeFormat', (value) => {
  return moment(value).format(timeFormat)
})

Vue.filter('fromNow', (value) => {
  return moment(value).fromNow()
})

const router = new VRouter({
  // Set to true to remove #! in path.
  // It needs proper configured server.
  // http://readystate4.com/2012/05/17/nginx-and-apache-rewrite-to-support-html5-pushstate/
  history: true
})
const application = Vue.extend({
  store,
  components: { App }
})
router.start(application, 'body')



// WEBPACK FOOTER //
// ./src/main.js